import { render, staticRenderFns } from "./benefits-settings-form.vue?vue&type=template&id=7fda73f4&scoped=true"
import script from "./benefits-settings-form.vue?vue&type=script&lang=js"
export * from "./benefits-settings-form.vue?vue&type=script&lang=js"
import style0 from "./benefits-settings-form.vue?vue&type=style&index=0&id=7fda73f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fda73f4",
  null
  
)

export default component.exports